/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_RetakeInputs */

const en_mobile_scan_retake = /** @type {(inputs: Mobile_Scan_RetakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retake`)
};

const es_mobile_scan_retake = /** @type {(inputs: Mobile_Scan_RetakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a tomar`)
};

/**
* | output |
* | --- |
* | "Retake" |
*
* @param {Mobile_Scan_RetakeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_retake = /** @type {((inputs?: Mobile_Scan_RetakeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_RetakeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_retake(inputs)
	return en_mobile_scan_retake(inputs)
});